export class InvoiceData {
  static ADDRESS: string =
    'Gala No 10B & 11B, J-514\nGoyal Industrial Premises Co-op Ltd.,\nTelco Road, Bhosari,\nPune 411026'

  static GSTNO: string = 'GSTIN: 27ABXFA7296C1ZV'

  static PURCHASE_ORDER_MOBILENO: string = '+91 8432413151'

  static QUOTATION_EMAILADDRESS: string = 'connect@arihantatf.com'

  static PURCHASE_ORDER_EMAILADDRESS: string = 'procurement@arihantatf.com'

  static IEC: string = 'IEC: ABXFA7296C'

  static EXPORT_EMAILADDRESS: string = 'Mail: exports@arihantatf.com'

  static ADDITIONALNOTES: string =
    'We reserve the right to correct the pricing offered due to any typographical errors.'

  static BANKDETAILS: any = {
    "ACCOUNT NAME": 'Arihant Tubes and Fittings',
    "CURRENT ACCOUNT NO": '9372055486',
    "BRANCH NAME": 'Pune - Bhosari',
    "BRANCH CODE": '1774',
    "IFSC CODE": 'KKBK0001774',
  }

  static convertNumberToWords(amount: number): string {
    const one = [
      '',
      'one ',
      'two ',
      'three ',
      'four ',
      'five ',
      'six ',
      'seven ',
      'eight ',
      'nine ',
      'ten ',
      'eleven ',
      'twelve ',
      'thirteen ',
      'fourteen ',
      'fifteen ',
      'sixteen ',
      'seventeen ',
      'eighteen ',
      'nineteen ',
    ]

    const ten = [
      '',
      '',
      'twenty ',
      'thirty ',
      'forty ',
      'fifty ',
      'sixty ',
      'seventy ',
      'eighty ',
      'ninety ',
    ]

    function numToWords(n: number, suffix: string): string {
      if (n === 0) return ''
      let str = ''
      if (n > 19) {
        str += ten[Math.floor(n / 10)] + (n % 10 !== 0 ? one[n % 10] : '')
      } else {
        str += one[n]
      }
      return str + suffix
    }

    if (amount === 0) return 'Rupees zero only'

    let out = ''
    const integerPart = Math.floor(amount)
    const decimalPart = Math.round((amount - integerPart) * 100)

    out += numToWords(Math.floor(integerPart / 10000000), 'crore ')
    out += numToWords(Math.floor((integerPart / 100000) % 100), 'lakh ')
    out += numToWords(Math.floor((integerPart / 1000) % 100), 'thousand ')
    out += numToWords(Math.floor((integerPart / 100) % 10), 'hundred ')

    if (integerPart > 100 && integerPart % 100 !== 0) {
      out += 'and '
    }

    out += numToWords(integerPart % 100, '')

    out = out.trim()

    let result = 'Rupees ' + out

    if (decimalPart > 0) {
      result += ' and ' + numToWords(decimalPart, '') + 'paise'
    }

    return result.charAt(0).toUpperCase() + result.slice(1) + ' only'
  }
}
